import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@feature/_app_modules/shared/shared.module';
import { EmptyLayoutComponent } from '@feature/_app_modules/layout/layouts/empty-layout/empty-layout/empty-layout.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [EmptyLayoutComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    EmptyLayoutComponent
    ]
})
export class EmptyModule { }
